import clsx from "clsx"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { ComponentPropsWithoutRef, FC } from "react"
import { hapticFeedback } from "utils/hapticFeedback"
import Container from "ui/container"
import { exclamationMarkIcon } from "assets/icons"
import styles from "./index.module.scss"

export interface ISideMenuItem extends ComponentPropsWithoutRef<"a"> {
  name: string
  link?: string
  color: string
  icon: string
  title: string
  hasIndicator?: boolean
}

export const SideMenuItem: FC<ISideMenuItem> = ({
  name,
  link,
  color,
  title,
  icon,
  hasIndicator,

  onClick,
  ...props
}) => {
  const { i18n } = useTranslation()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick || link) {
      hapticFeedback()

      if (onClick) {
        e.preventDefault()
        onClick(e)
      }
    }
  }

  return (
    <Link
      {...props}
      className="hover-effect"
      to={link ? link : ""}
      onClick={handleClick}
    >
      <Container
        className={clsx(
          styles.SideMenuItem,
          styles[i18n.language],
          styles[name]
        )}
        style={{ backgroundColor: color }}
      >
        <img src={icon} alt={title} />

        <p>{title}</p>

        {hasIndicator && (
          <div className={styles.SideMenuItem_indicator}>
            <img src={exclamationMarkIcon} alt="" />
          </div>
        )}

        {["big", "small"].map((e, i) => (
          <div
            className={clsx(
              "triangle",
              styles.SideMenuItem_triangle,
              styles[e]
            )}
            key={i}
          />
        ))}
      </Container>
    </Link>
  )
}
